export function formatStandard(standard) {
  const n = Number(standard);
  if (Number.isNaN(n)) return "";
  if (n === -3) return "Nursery";
  if (n === -2) return "LKG";
  if (n === -1) return "UKG";
  return "Standard " + n;
}
